import { defineStore } from 'pinia'
import { ref } from 'vue'

import { useCefFilterStore } from './cefFilter'

export const usePreviewCefStore = defineStore('previewCef', () => {
	const previewCef = ref<{
		cefId: number
		cefProgressStage: string
	}>()

	const searchSpecificCef = async (value: {
		cefId: number
		cefProgressStage: string
	}) => {
		try {
			if (!value?.cefId || !value?.cefProgressStage) {
				console.warn('Parámetros inválidos para búsqueda de CEF:', value)
				return
			}

			const validStages = ['current', 'past', 'future', 'cancelled']
			if (!validStages.includes(value.cefProgressStage)) {
				console.warn('Progress stage inválido:', value.cefProgressStage)
				return
			}

			const { params } = useCefFilterStore()

			params.cef = String(value.cefId)
			params.progressStage = value.cefProgressStage

			previewCef.value = value

			return true
		} catch (error) {
			console.error('Error en búsqueda específica de CEF desde store:', error)
			return false
		}
	}

	return {
		previewCef,
		setPreviewCef(value: { cefId: number; cefProgressStage: string }) {
			previewCef.value = value
		},
		searchSpecificCef,
		clearPreviewCef() {
			previewCef.value = undefined
		},
		resetState() {
			previewCef.value = undefined
		},
	}
})
